import React from 'react';

function Preloader({ asOverlay }) {
    return <div className={`wcf-ui-preloader ${asOverlay === true ? 'as-overlay' : ''}`} />;
}

export default Preloader;
